import { Injectable, inject } from '@angular/core';
import { LocalStorageKeys, LocalStorageService } from '@iot-platform/core';

@Injectable({
  providedIn: 'root'
})
export class ResizeStorageService {
  private readonly storage = inject(LocalStorageService);

  getWidth(pageName: string): string | null {
    return this.storage.get(`${LocalStorageKeys.STORAGE_RESIZE_ELEMENT}-${pageName}`);
  }

  setWidth(pageName: string, width: string): void {
    this.storage.set(`${LocalStorageKeys.STORAGE_RESIZE_ELEMENT}-${pageName}`, width);
  }
}
